export default __webpack_public_path__ + "static/media/video_example.b777029e.png";